import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import IconButton from 'material-ui/IconButton';
import CourseEnrolmentEditDialog from './CourseEnrolmentEditDialog';
import IconMenu from 'material-ui/IconMenu';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import LaunchIcon from 'material-ui/svg-icons/action/launch';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import PrivateIcon from 'material-ui/svg-icons/action/lock';
import SpotIcon from 'material-ui/svg-icons/image/lens';
import SkillIcon from 'material-ui/svg-icons/social/public';

import LinearProgress from 'material-ui/LinearProgress';
import CourseProgressBar from '../ProgressBar/CourseProgressBar';
import { avatar as avatarColours, statusColours } from '../../constants/ColourConstants';
import CourseActions from '../../actions/CourseActionCreator';
import CourseStore from '../../stores/CourseStore';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import * as Colors from 'material-ui/styles/colors';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
};

const CourseEnrolmentListItem = React.createClass({

    getInitialState: function() {
        return ({editDialogOpen: false});
    },

    getActions: function(row) {

        return [
            {
                action: () => this.setState({editDialogOpen: true}),
                label: 'Edit',
                icon: <EditIcon />,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete',
                deleteAction: this.props.deleteAction||this.onEnrolmentDelete,
                message: (
                    <span>Delete this enrolment?</span>
                ),
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    },


    render: function() {

        const row = this.props.data;
        const infoLink = `/dashboard/course/enrolment/${row.id}`;
        const actions = (this.props.actions || this.getActions(row));
        const menuItems = buildContextMenu(actions, this.context.auth);
        const success = (row.status === 'completed');
        const cancelled = (row.status === 'cancelled');


        let listItemProps = {
            key: row.id,
            style: style.listItem,
            secondaryTextLines: 2
        };

        let description = '';
        let avatarIcon  = <SchoolIcon />;
        let avatarStyle = avatarColours.default;

        const enrolmentMethod = (row.isAssigned ? 'Assigned' : 'Booked');

        let iconGroup = [];
        if (row.visibility === 'private') {
            iconGroup.push(<PrivateIcon className="icon-small"  key="visibility" />);
        }

        if (row.skillId) {
            iconGroup.push(<SkillIcon className="icon-small"  key="skill" />);
        }

        if (row.isAssigned) {
            if (row.isMandatory) {
                iconGroup.push(<SpotIcon className="icon-small" color={statusColours.mandatory} key="mandatory"/>);
            } else {
                iconGroup.push(<SpotIcon className="icon-small" color={statusColours.optional} key="optional"/>);
            }
        }

        listItemProps.primaryText = (<Link to={infoLink} className="primaryText">{row.courseName}</Link>);


        switch(row.status) {

            case 'waiting':
                description   = 'On waiting list';
                break;

            case 'enrolled':

                description  = enrolmentMethod;

                if (!!row.dateStart) {
                    const enrolmentDate = new Date(row.dateStart);
                    if (!!enrolmentDate && !isNaN(enrolmentDate.valueOf())) {
                        description += ` on ${enrolmentDate.toDateString()}`;
                    }
                }
                break;

            case 'completed':
                avatarStyle = avatarColours.moduleCompleted;
                description = 'Completed';
                if (!!row.dateCompleted) {
                    const completedDate = new Date(row.dateCompleted);
                    if (!!completedDate && !isNaN(completedDate.valueOf())) {
                        description += ` on ${completedDate.toDateString()}`;
                    }
                }

                if (!!row.score) {
                    description += ` - Score:  ${row.score}`;
                }
                break;

            case 'cancelled':
                avatarStyle = avatarColours.cancelled;
                description = `Cancelled`;
                break;

            default:
                break;
        }


        switch(row.courseType) {

            case 'classroom':
                avatarIcon = (<SchoolIcon />);
                break;

            case 'e-learning':
                avatarIcon = (<LaunchIcon />);
                break;

            default:
                break;
        }

        listItemProps.leftAvatar=(
            <Link to={infoLink}>
                <Avatar icon={avatarIcon} style={avatarStyle} />
            </Link>
        );

        if (row.loading) {
            listItemProps.secondaryText = <div><LinearProgress mode="indeterminate"/></div>;
        } else if (row.secondaryText) {
            listItemProps.secondaryText = <Link to={infoLink} className="secondaryInfo">{row.secondaryText}</Link>;
            listItemProps.secondaryTextLines = (row.secondaryTextLines || 2);
        } else {
            listItemProps.secondaryText = (
                <div className="secondaryInfo">
                    <CourseProgressBar courseId={row.courseId} userId={row.userId} success={success} cancelled={cancelled}/>
                    {iconGroup}<em>{description}</em>
                </div>
            );
            listItemProps.secondaryTextLines = 2;
        }

        if (menuItems.length > 0) {
            const topRight = {horizontal: 'right', vertical: 'top'};
            const iconMenuProps = {
                menuStyle: style.menu,
                anchorOrigin: topRight,
                targetOrigin: topRight,
                iconButtonElement: (
                    <IconButton touch={true} >
                        <MoreVertIcon color={Colors.grey400} style={style.iconButton} />
                    </IconButton>
                )
            };
            listItemProps.rightIcon = (
                <IconMenu {...iconMenuProps} >
                    {menuItems}
                </IconMenu>
            );
        }

        return (
            <div>
                <ListItem {...listItemProps} />
                <CourseEnrolmentEditDialog
                    open={this.state.editDialogOpen}
                    statusList={CourseStore.getStatuses()}
                    onCancel={this.closeEditDialog}
                    onClose={this.closeEditDialog}
                    onSave={this.editEnrolment}
                    data={{
                        status: row.status,
                        score: row.score,
                        isMandatory: row.isMandatory,
                        canRetake: row.canRetake,
                        dateStart: row.dateStart,
                        dateCompleted: row.dateCompleted
                }}
                    closeOnSave
                />
            </div>
        );
    },
    
    onEnrolmentDelete: function(enrolmentId) {
        if (!!this.props.data.courseId && !!this.props.data.id) {
            CourseActions.deleteEnrolment(this.props.data);
        }
    },

    closeEditDialog: function() {
        this.setState({editDialogOpen: false});
    },

    editEnrolment: function(changes) {
        CourseActions.updateEnrolment(this.props.data.courseId, this.props.data.id, changes);
    }
});


CourseEnrolmentListItem.propTypes = {
    deleteAction: PropTypes.func
};

CourseEnrolmentListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CourseEnrolmentListItem;
